import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if (or this.loading this.groups.canLoadMore)}}
  {{hide-application-footer}}
{{/if}}

{{body-class "groups-page"}}

<PluginOutlet @name="before-groups-index-container" @connectorTagName="div" />

<section class="container groups-index">
  <div class="groups-header">
    {{#if this.currentUser.can_create_group}}
      <DButton
        @action={{this.new}}
        @icon="plus"
        @label="admin.groups.new.title"
        class="btn-default groups-header-new pull-right"
      />
    {{/if}}

    <div class="groups-header-filters">
      <Input
        @value={{readonly this.filter}}
        placeholder={{i18n "groups.index.all"}}
        class="groups-header-filters-name no-blur"
        {{on "input" (with-event-value this.onFilterChanged)}}
        @type="search"
        aria-description={{i18n "groups.index.search_results"}}
      />

      <ComboBox
        @value={{this.type}}
        @content={{this.types}}
        @onChange={{fn (mut this.type)}}
        @options={{hash clearable=true none="groups.index.filter"}}
        class="groups-header-filters-type"
      />
    </div>
  </div>

  <ConditionalLoadingSpinner @condition={{this.isLoading}}>
    {{#if this.groups}}
      <LoadMore
        @selector=".groups-boxes .group-box"
        @action={{action "loadMore"}}
      >
        <div class="container">
          <div class="groups-boxes">
            {{#each this.groups as |group|}}
              <LinkTo
                @route="group.members"
                @model={{group.name}}
                class="group-box"
                data-group-name={{group.name}}
              >
                <div class="group-box-inner">
                  <div class="group-info-wrapper">
                    {{#if group.flair_url}}
                      <span class="group-avatar-flair">
                        <AvatarFlair
                          @flairName={{group.name}}
                          @flairUrl={{group.flair_url}}
                          @flairBgColor={{group.flair_bg_color}}
                          @flairColor={{group.flair_color}}
                        />
                      </span>
                    {{/if}}

                    <span class="group-info">
                      <GroupsInfo @group={{group}} />
                      <div class="group-user-count">{{d-icon
                          "user"
                        }}{{group.user_count}}</div>
                    </span>
                  </div>

                  <div class="group-description">{{html-safe
                      group.bio_excerpt
                    }}</div>

                  <div class="group-membership">
                    <GroupMembershipButton
                      @tagName=""
                      @model={{group}}
                      @showLogin={{route-action "showLogin"}}
                    >
                      {{#if group.is_group_owner}}
                        <span class="is-group-owner">
                          {{d-icon "shield-alt"}}
                          {{i18n "groups.index.is_group_owner"}}
                        </span>
                      {{else if group.is_group_user}}
                        <span class="is-group-member">
                          {{d-icon "check"}}
                          {{i18n "groups.index.is_group_user"}}
                        </span>
                      {{else if group.public_admission}}
                        {{i18n "groups.index.public"}}
                      {{else if group.isPrivate}}
                        {{d-icon "far-eye-slash"}}
                        {{i18n "groups.index.private"}}
                      {{else}}
                        {{#if group.automatic}}
                          {{i18n "groups.index.automatic"}}
                        {{else}}
                          {{d-icon "ban"}}
                          {{i18n "groups.index.closed"}}
                        {{/if}}
                      {{/if}}
                    </GroupMembershipButton>

                    <span>
                      <PluginOutlet
                        @name="group-index-box-after"
                        @connectorTagName="div"
                        @outletArgs={{hash model=group}}
                      />
                    </span>
                  </div>
                </div>
              </LinkTo>
            {{/each}}
          </div>
        </div>
      </LoadMore>

      <ConditionalLoadingSpinner @condition={{this.groups.loadingMore}} />
    {{else}}
      <p role="status">{{i18n "groups.index.empty"}}</p>
    {{/if}}
  </ConditionalLoadingSpinner>
</section>

<PluginOutlet @name="after-groups-index-container" @connectorTagName="div" />
*/
{
  "id": "7SZRlsnP",
  "block": "[[[41,[28,[37,1],[[30,0,[\"loading\"]],[30,0,[\"groups\",\"canLoadMore\"]]],null],[[[1,\"  \"],[1,[34,2]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,[28,[35,3],[\"groups-page\"],null]],[1,\"\\n\\n\"],[8,[39,4],null,[[\"@name\",\"@connectorTagName\"],[\"before-groups-index-container\",\"div\"]],null],[1,\"\\n\\n\"],[10,\"section\"],[14,0,\"container groups-index\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"groups-header\"],[12],[1,\"\\n\"],[41,[30,0,[\"currentUser\",\"can_create_group\"]],[[[1,\"      \"],[8,[39,5],[[24,0,\"btn-default groups-header-new pull-right\"]],[[\"@action\",\"@icon\",\"@label\"],[[30,0,[\"new\"]],\"plus\",\"admin.groups.new.title\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[10,0],[14,0,\"groups-header-filters\"],[12],[1,\"\\n      \"],[8,[39,6],[[16,\"placeholder\",[28,[37,7],[\"groups.index.all\"],null]],[24,0,\"groups-header-filters-name no-blur\"],[16,\"aria-description\",[28,[37,7],[\"groups.index.search_results\"],null]],[4,[38,9],[\"input\",[28,[37,10],[[30,0,[\"onFilterChanged\"]]],null]],null]],[[\"@value\",\"@type\"],[[28,[37,8],[[30,0,[\"filter\"]]],null],\"search\"]],null],[1,\"\\n\\n      \"],[8,[39,11],[[24,0,\"groups-header-filters-type\"]],[[\"@value\",\"@content\",\"@onChange\",\"@options\"],[[30,0,[\"type\"]],[30,0,[\"types\"]],[28,[37,12],[[28,[37,13],[[30,0,[\"type\"]]],null]],null],[28,[37,14],null,[[\"clearable\",\"none\"],[true,\"groups.index.filter\"]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,15],null,[[\"@condition\"],[[30,0,[\"isLoading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"groups\"]],[[[1,\"      \"],[8,[39,16],null,[[\"@selector\",\"@action\"],[\".groups-boxes .group-box\",[28,[37,17],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"container\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"groups-boxes\"],[12],[1,\"\\n\"],[42,[28,[37,19],[[28,[37,19],[[30,0,[\"groups\"]]],null]],null],null,[[[1,\"              \"],[8,[39,20],[[24,0,\"group-box\"],[16,\"data-group-name\",[30,1,[\"name\"]]]],[[\"@route\",\"@model\"],[\"group.members\",[30,1,[\"name\"]]]],[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"group-box-inner\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"group-info-wrapper\"],[12],[1,\"\\n\"],[41,[30,1,[\"flair_url\"]],[[[1,\"                      \"],[10,1],[14,0,\"group-avatar-flair\"],[12],[1,\"\\n                        \"],[8,[39,21],null,[[\"@flairName\",\"@flairUrl\",\"@flairBgColor\",\"@flairColor\"],[[30,1,[\"name\"]],[30,1,[\"flair_url\"]],[30,1,[\"flair_bg_color\"]],[30,1,[\"flair_color\"]]]],null],[1,\"\\n                      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n                    \"],[10,1],[14,0,\"group-info\"],[12],[1,\"\\n                      \"],[8,[39,22],null,[[\"@group\"],[[30,1]]],null],[1,\"\\n                      \"],[10,0],[14,0,\"group-user-count\"],[12],[1,[28,[35,23],[\"user\"],null]],[1,[30,1,[\"user_count\"]]],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n\\n                  \"],[10,0],[14,0,\"group-description\"],[12],[1,[28,[35,24],[[30,1,[\"bio_excerpt\"]]],null]],[13],[1,\"\\n\\n                  \"],[10,0],[14,0,\"group-membership\"],[12],[1,\"\\n                    \"],[8,[39,25],null,[[\"@tagName\",\"@model\",\"@showLogin\"],[\"\",[30,1],[28,[37,26],[\"showLogin\"],null]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,1,[\"is_group_owner\"]],[[[1,\"                        \"],[10,1],[14,0,\"is-group-owner\"],[12],[1,\"\\n                          \"],[1,[28,[35,23],[\"shield-alt\"],null]],[1,\"\\n                          \"],[1,[28,[35,7],[\"groups.index.is_group_owner\"],null]],[1,\"\\n                        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"is_group_user\"]],[[[1,\"                        \"],[10,1],[14,0,\"is-group-member\"],[12],[1,\"\\n                          \"],[1,[28,[35,23],[\"check\"],null]],[1,\"\\n                          \"],[1,[28,[35,7],[\"groups.index.is_group_user\"],null]],[1,\"\\n                        \"],[13],[1,\"\\n\"]],[]],[[[41,[30,1,[\"public_admission\"]],[[[1,\"                        \"],[1,[28,[35,7],[\"groups.index.public\"],null]],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isPrivate\"]],[[[1,\"                        \"],[1,[28,[35,23],[\"far-eye-slash\"],null]],[1,\"\\n                        \"],[1,[28,[35,7],[\"groups.index.private\"],null]],[1,\"\\n\"]],[]],[[[41,[30,1,[\"automatic\"]],[[[1,\"                          \"],[1,[28,[35,7],[\"groups.index.automatic\"],null]],[1,\"\\n\"]],[]],[[[1,\"                          \"],[1,[28,[35,23],[\"ban\"],null]],[1,\"\\n                          \"],[1,[28,[35,7],[\"groups.index.closed\"],null]],[1,\"\\n\"]],[]]],[1,\"                      \"]],[]]]],[]]]],[]]]],[]]],[1,\"                    \"]],[]]]]],[1,\"\\n\\n                    \"],[10,1],[12],[1,\"\\n                      \"],[8,[39,4],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"group-index-box-after\",\"div\",[28,[37,14],null,[[\"model\"],[[30,1]]]]]],null],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n\"]],[1]],null],[1,\"          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[39,15],null,[[\"@condition\"],[[30,0,[\"groups\",\"loadingMore\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,2],[14,\"role\",\"status\"],[12],[1,[28,[35,7],[\"groups.index.empty\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"  \"]],[]]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,4],null,[[\"@name\",\"@connectorTagName\"],[\"after-groups-index-container\",\"div\"]],null]],[\"group\"],false,[\"if\",\"or\",\"hide-application-footer\",\"body-class\",\"plugin-outlet\",\"d-button\",\"input\",\"i18n\",\"readonly\",\"on\",\"with-event-value\",\"combo-box\",\"fn\",\"mut\",\"hash\",\"conditional-loading-spinner\",\"load-more\",\"action\",\"each\",\"-track-array\",\"link-to\",\"avatar-flair\",\"groups-info\",\"d-icon\",\"html-safe\",\"group-membership-button\",\"route-action\"]]",
  "moduleName": "discourse/templates/groups/index.hbs",
  "isStrictMode": false
});